const AUTH_CONFIG_URL = '/auth.config.json';

export type AuthConfigFile = {
  keyCloakURL: string;
  keyCloakRealm: string;
  keyCloakClientId: string;
};

let authConfigPromise: Promise<AuthConfigFile> | null = null;

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

function parseAuthConfigFile(data: unknown): AuthConfigFile {
  if (!data || typeof data !== 'object') {
    throw new Error('auth.config.json must be a JSON object');
  }

  const record = data as Record<string, unknown>;

  if (!isNonEmptyString(record.keyCloakURL)) {
    throw new Error('auth.config.json is missing keyCloakURL');
  }

  if (!isNonEmptyString(record.keyCloakRealm)) {
    throw new Error('auth.config.json is missing keyCloakRealm');
  }

  if (!isNonEmptyString(record.keyCloakClientId)) {
    throw new Error('auth.config.json is missing keyCloakClientId');
  }

  return {
    keyCloakURL: record.keyCloakURL.trim(),
    keyCloakRealm: record.keyCloakRealm.trim(),
    keyCloakClientId: record.keyCloakClientId.trim(),
  };
}

export function loadAuthConfigFile(): Promise<AuthConfigFile> {
  if (!authConfigPromise) {
    authConfigPromise = fetch(AUTH_CONFIG_URL).then(async (response) => {
      if (!response.ok) {
        throw new Error(
          `Failed to load auth.config.json (${response.status} ${response.statusText})`,
        );
      }

      return parseAuthConfigFile(await response.json());
    });
  }

  return authConfigPromise;
}
